import styled from '../../../utils/styled';
import {SelectionControlStateProps, SelectionControlWrapperProps} from '../../SelectionControl';

type CheckboxWrapperProps = SelectionControlWrapperProps & SelectionControlStateProps;

export default styled('label')<CheckboxWrapperProps>(({disabled}) => ({
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  cursor: disabled ? 'not-allowed' : 'pointer',
  outline: 0
}));



// WEBPACK FOOTER //
// ./src/components/Checkbox/private/CheckboxWrapper.tsx